module.exports = __webpack_public_path__ + "static/media/21a.abb120f5.jpg";